import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './languages/en.json';
import ru from './languages/ru.json';

i18n.use(LanguageDetector).use(initReactI18next).init({
    debug: false,
    fallbackLng: 'ru',
    resources: {
        en,
        ru,
    },
});

export default i18n;
